import { z } from 'zod';
import { StockMovementType } from '../enums.js';

/** Admin restock workflow (spec section 7). */
export const restockSchema = z.object({
  variantId: z.string().uuid(),
  locationId: z.string().uuid(),
  quantity: z.number().int().min(1),
  unitCost: z.number().int().min(0).nullable().optional(),
  supplierReference: z.string().max(120).nullable().optional(),
  receivedDate: z.string().datetime().optional(),
  notes: z.string().max(1000).nullable().optional(),
});

/** Manual adjustments require a mandatory reason (spec section 7). */
export const adjustSchema = z.object({
  variantId: z.string().uuid(),
  locationId: z.string().uuid(),
  // Signed delta: negative removes stock (damage, correction), positive adds
  delta: z.number().int().refine((v) => v !== 0, 'delta cannot be zero'),
  type: z
    .enum([
      StockMovementType.MANUAL_ADJUSTMENT,
      StockMovementType.DAMAGE,
      StockMovementType.RETURN,
      StockMovementType.TRANSFER,
    ])
    .default(StockMovementType.MANUAL_ADJUSTMENT),
  reason: z.string().min(3).max(1000),
  toLocationId: z.string().uuid().optional(), // for TRANSFER
});

export const stockMovementQuerySchema = z.object({
  variantId: z.string().uuid().optional(),
  locationId: z.string().uuid().optional(),
  type: z.nativeEnum(StockMovementType).optional(),
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(50),
});

export type RestockInput = z.infer<typeof restockSchema>;
export type AdjustInput = z.infer<typeof adjustSchema>;
